import SearchableSelect from './SearchableSelect';
import { candidateDisplayName, candidateSearchText } from './entitySearchLabels';

export default function SearchableCandidateSelect({
  candidates = [],
  value,
  onChange,
  placeholder = 'Search by name, mobile, or email…',
  className = ''
}) {
  return (
    <SearchableSelect
      items={candidates}
      value={value}
      onChange={onChange}
      getValue={c => c.id}
      getLabel={candidateDisplayName}
      getSearchText={candidateSearchText}
      placeholder={placeholder}
      hint="Search by name, mobile, or email — list shows candidate name"
      showHint
      className={className}
      clearAriaLabel="Clear candidate"
    />
  );
}
